export default __webpack_public_path__ + "static/media/MS-Sans-Serif.93905f8d.ttf";